// "Hoje" é sempre a data no fuso da empresa (como app.hoje() no banco),
// nunca a data UTC — os programas antigos erravam o dia depois das 21h.
export const FUSO_PADRAO = 'America/Sao_Paulo';

export function hoje(fuso = FUSO_PADRAO, agora = new Date()) {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: fuso || FUSO_PADRAO,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(agora);
  const valor = (tipo) => partes.find((p) => p.type === tipo).value;
  return `${valor('year')}-${valor('month')}-${valor('day')}`;
}

// Dia seguinte (AAAA-MM-DD)
export function diaSeguinte(dia) {
  const [a, m, d] = dia.split('-').map(Number);
  return new Date(Date.UTC(a, m - 1, d + 1)).toISOString().slice(0, 10);
}

// Diferença em dias entre duas datas AAAA-MM-DD (b − a).
export function diasEntre(a, b) {
  const [ya, ma, da] = a.split('-').map(Number);
  const [yb, mb, db] = b.split('-').map(Number);
  return Math.round((Date.UTC(yb, mb - 1, db) - Date.UTC(ya, ma - 1, da)) / 86400000);
}

export const FUSOS = [
  ['America/Sao_Paulo', 'Horário de Brasília'],
  ['America/Cuiaba', 'Mato Grosso'],
  ['America/Campo_Grande', 'Mato Grosso do Sul'],
  ['America/Porto_Velho', 'Rondônia'],
  ['America/Manaus', 'Amazonas'],
  ['America/Boa_Vista', 'Roraima'],
  ['America/Rio_Branco', 'Acre'],
  ['America/Noronha', 'Fernando de Noronha'],
];
